import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import AddressPostCodeComponentPage from './AddressPostCodeComponentPage';
import {
  onFindAddressClick,
  onSelectAddressClick,
  onAddManuallyClick,
  addressSelector
} from '../../infrastructure/address';
import { resetRequiredFields, isGivenAddress } from './addressUtils/addressUtils';
import AddressComponentConditional from './AddressComponentConditional';
import ShowAddress from './components/ShowAddress';
class AddressComponent extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditMode: false };
    this.onEditClick = this.onEditClick.bind(this);
  }

  componentDidUpdate() {
    const { type, formValues, isAddMunuallyClicked, isPostCodeOnly } = this.props;
    resetRequiredFields(isAddMunuallyClicked, type, formValues, isPostCodeOnly);
  }

  onEditClick() {
    this.setState({ isEditMode: true });
  }

  render() {
    const {
      type,
      formValues,
      onAddManuallyClick,
      onFindAddressClick,
      onSelectAddressClick,
      isPostCodeOnly,
      isAddMunuallyClicked,
      postCodeAddressList,
      chooseAddressHeading,
      currentIndex,
      isPostCodeListError
    } = this.props;
    return (
      <div>
        {isGivenAddress(formValues, this.state.isEditMode, type) && (
          <ShowAddress
            type={type}
            value={formValues[type].givenAddress}
            onEditClick={this.onEditClick}
          />
        )}
        {!isGivenAddress(formValues, this.state.isEditMode, type) && (
          <div>
            {' '}
            {isPostCodeOnly ? (
              <AddressPostCodeComponentPage
                type={type}
                onFindAddressClick={postCode => {
                  onFindAddressClick(postCode, type, currentIndex);
                }}
                onAddManuallyClick={v => {
                  onAddManuallyClick(type, v, currentIndex);
                }}
                postCodeAddressList={postCodeAddressList}
                isAddMunuallyClicked={isAddMunuallyClicked}
                onSelectAddressClick={onSelectAddressClick}
                isPostCodeOnly={isPostCodeOnly}
                isPostCodeListError={isPostCodeListError}
                currentIndex={currentIndex}
                formValues={formValues}
              />
            ) : (
              <AddressComponentConditional
                type={type}
                onFindAddressClick={postCode => {
                  onFindAddressClick(postCode, type, currentIndex);
                }}
                onAddManuallyClick={v => {
                  onAddManuallyClick(type, v, currentIndex);
                }}
                postCodeAddressList={postCodeAddressList}
                isAddMunuallyClicked={isAddMunuallyClicked}
                onSelectAddressClick={onSelectAddressClick}
                chooseAddressHeading={chooseAddressHeading}
                isPostCodeListError={isPostCodeListError}
                currentIndex={currentIndex}
                formValues={formValues}
              />
            )}
          </div>
        )}
      </div>
    );
  }
}

AddressComponent.propTypes = {
  type: PropTypes.string,
  postCodeAddressList: PropTypes.array,
  isPostCodeListError: PropTypes.bool
};

const mapStateToProps = (state, ownProps) => {
  return {
    isAddMunuallyClicked: addressSelector.isAddManuallyClicked(
      state,
      ownProps.type,
      ownProps.currentIndex
    ),
    postCodeAddressList: addressSelector.postCodeAddressList(
      state,
      ownProps.type,
      ownProps.currentIndex
    ),
    isPostCodeListError: addressSelector.isPostCodeListError(
      state,
      ownProps.type,
      ownProps.currentIndex
    )
  };
};

const actionCreators = {
  onFindAddressClick,
  onSelectAddressClick,
  onAddManuallyClick
};

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AddressComponent);
